import React from "react";
import Chart from "../../../chart";
import { useSelector } from "react-redux";
import { Skeleton, Empty, theme } from "antd";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { hms, onlyHoursNumber } from "utils/timeConverter";
import { useBranding } from "hooks/useBranding";

dayjs.extend(duration);

const UserCompairsonTeamWiseRadar = (props) => {
  const branding = useBranding();
  const Cardskeleton = () => {
    return (
      <div className="charts">
        <div className="chart_header">
          <Skeleton.Input size={"small"} style={{ height: "15px" }} />
          <Skeleton.Avatar
            size={"small"}
            shape={"circle"}
            style={{ height: "15px", width: "15px" }}
          />
        </div>
        <div className="chartContainer chart_tool" id="chart">
          <Skeleton.Avatar
            size={"large"}
            style={{ height: "300px", width: "100%" }}
          />
        </div>
      </div>
    );
  };

  Cardskeleton.propTypes = {
    loading: PropTypes.bool,
  };

  const userscorecard = useSelector(
    (
      state // @ts-ignore
    ) => state.userScoreCard
  );
  const seriesColors = [branding?.theme?.primary || "#7b61ff", "#0A9888"];

  const {
    userPerformance,
    teamPerformance,
    userComparativeDurationPerformance,
    teamComparativeDurationPerformance,
  } = props;

  // Convert data to HH:mm:ss format
  const formatData = (data) => {
    return data.map((value) => hms(value));
  };

  const formattedUserPerformance = formatData(
    userComparativeDurationPerformance
  );
  const formattedTeamPerformance = formatData(
    teamComparativeDurationPerformance
  );

  const chartOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    colors: seriesColors,
    stroke: {
      width: 2,
    },
    fill: {
      opacity: 0.1,
    },
    markers: {
      size: 4,
      colors: seriesColors,
      strokeWidth: 2,
    },
    yaxis: {
      labels: {
        formatter: (value) => value,
      },
      stepSize: 2,
    },
    xaxis: {
      categories: [
        "Avg Working time",
        "Avg Active time",
        "Avg Online time",
        "Avg Productive time",
        "Avg Idle time",
      ],
    },
    tooltip: {
      theme: "light",
      // y: {
      //   formatter: (value) =>
      //     dayjs.duration(value, "seconds").format("HH:mm:ss"),
      // },
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const name = seriesIndex === 0 ? "Individual user" : "Team";
        const value =
          seriesIndex === 0
            ? formattedUserPerformance[dataPointIndex]
            : formattedTeamPerformance[dataPointIndex];
        const category = w.config.xaxis.categories[dataPointIndex];
        const color =
          seriesIndex === 0 ? w.globals.colors[0] : w.globals.colors[1];
        return (
          '<div class="bartooltip">' +
          category +
          '</div></div><div class="tooltip_card"><div class="w_data"><div class="colordot" style="background:' +
          color +
          '"></div>' +
          name +
          '<div class="w_value">' +
          value +
          '</div></div><div class="w_data"><div class="colordot" style="background:' +
          "</div></div></div>"
        );
      },
    },
  };

  const appusages = {
    series: [
      {
        name: "Individual user",
        data: userPerformance,
      },
      {
        name: "Team",
        data: teamPerformance,
      },
    ],
  };

  return (
    <>
      {userscorecard.comparative_analysis_user_performance_processing ? (
        <Cardskeleton />
      ) : (
        <div className="scorecard shadow-none border-0">
          <div className="chartContainer all_tool" id="chart">
            {userPerformance && userPerformance.length > 0 ? (
              <Chart
                options={chartOptions}
                series={appusages.series}
                type="radar"
                height={450}
                width={330}
              />
            ) : (
              <div style={{ height: 450 }} className="emptyblock">
                <Empty description={false} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default UserCompairsonTeamWiseRadar;
